// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"544":"1693ae67","896":"1cc1b457"}[chunkId] + ".js";
};